import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const PRODUCTS_PRODUCT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    // routes.add([
    //   {
    //     path: '/products',
    //     iconClass: 'fas fa-file-alt',
    //     name: '::Menu:Products',
    //     layout: eLayoutType.application,
    //     requiredPolicy: 'Ldm.Products',
    //   },
    // ]);
  };
}
